// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.container{
  width: 100%;
}
@media (min-width: 480px){
  .container{
    max-width: 480px;
  }
}
@media (min-width: 640px){
  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){
  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){
  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){
  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1536px){
  .container{
    max-width: 1536px;
  }
}
.visible{
  visibility: visible;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.inset-0{
  inset: 0px;
}
.bottom-10{
  bottom: 2.5rem;
}
.left-0{
  left: 0px;
}
.left-\\[-1px\\]{
  left: -1px;
}
.left-\\[100\\.7px\\]{
  left: 100.7px;
}
.left-\\[1610\\.7px\\]{
  left: 1610.7px;
}
.left-\\[35px\\]{
  left: 35px;
}
.right-10{
  right: 2.5rem;
}
.top-0{
  top: 0px;
}
.top-4{
  top: 1rem;
}
.top-\\[0\\]{
  top: 0;
}
.top-\\[100\\.8px\\]{
  top: 100.8px;
}
.top-\\[30px\\]{
  top: 30px;
}
.top-\\[55\\%\\]{
  top: 55%;
}
.top-\\[800\\.9px\\]{
  top: 800.9px;
}
.z-0{
  z-index: 0;
}
.z-10{
  z-index: 10;
}
.z-50{
  z-index: 50;
}
.m-0{
  margin: 0px;
}
.m-auto{
  margin: auto;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-8{
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.mr-4{
  margin-right: 1rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-\\[90vh\\]{
  margin-top: 90vh;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.flex{
  display: flex;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.size-6{
  width: 1.5rem;
  height: 1.5rem;
}
.h-12{
  height: 3rem;
}
.h-32{
  height: 8rem;
}
.h-48{
  height: 12rem;
}
.h-6{
  height: 1.5rem;
}
.h-8{
  height: 2rem;
}
.h-\\[20px\\]{
  height: 20px;
}
.h-\\[57\\.2px\\]{
  height: 57.2px;
}
.h-\\[94\\.8px\\]{
  height: 94.8px;
}
.h-auto{
  height: auto;
}
.h-full{
  height: 100%;
}
.h-screen{
  height: 100vh;
}
.min-h-screen{
  min-height: 100vh;
}
.w-6{
  width: 1.5rem;
}
.w-8{
  width: 2rem;
}
.w-\\[20px\\]{
  width: 20px;
}
.w-\\[57\\.2px\\]{
  width: 57.2px;
}
.w-\\[80\\%\\]{
  width: 80%;
}
.w-\\[85\\%\\]{
  width: 85%;
}
.w-\\[90\\%\\]{
  width: 90%;
}
.w-\\[94\\.8px\\]{
  width: 94.8px;
}
.w-full{
  width: 100%;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-7xl{
  max-width: 80rem;
}
.max-w-\\[100px\\]{
  max-width: 100px;
}
.max-w-full{
  max-width: 100%;
}
.max-w-xl{
  max-width: 36rem;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.flex-grow{
  flex-grow: 1;
}
.cursor-pointer{
  cursor: pointer;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.content-center{
  align-content: center;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.gap-2{
  gap: 0.5rem;
}
.gap-4{
  gap: 1rem;
}
.gap-6{
  gap: 1.5rem;
}
.space-x-20 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(5rem * var(--tw-space-x-reverse));
  margin-left: calc(5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.overflow-hidden{
  overflow: hidden;
}
.whitespace-normal{
  white-space: normal;
}
.text-pretty{
  text-wrap: pretty;
}
.break-words{
  overflow-wrap: break-word;
}
.rounded-8xs{
  border-radius: 5px;
}
.rounded-\\[10px\\]{
  border-radius: 10px;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-l-2xl{
  border-top-left-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.rounded-t-lg{
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.border{
  border-width: 1px;
}
.border-\\[4px\\]{
  border-width: 4px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-solid{
  border-style: solid;
}
.border-\\[\\#0E7090\\]{
  --tw-border-opacity: 1;
  border-color: rgb(14 112 144 / var(--tw-border-opacity, 1));
}
.border-deepskyblue-100{
  --tw-border-opacity: 1;
  border-color: rgb(6 174 212 / var(--tw-border-opacity, 1));
}
.bg-\\[\\#665D9B\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(102 93 155 / var(--tw-bg-opacity, 1));
}
.bg-azure{
  --tw-bg-opacity: 1;
  background-color: rgb(245 254 255 / var(--tw-bg-opacity, 1));
}
.bg-darkslateblue-200{
  background-color: rgba(59, 44, 124, 0.75);
}
.bg-deepskyblue-100{
  --tw-bg-opacity: 1;
  background-color: rgb(6 174 212 / var(--tw-bg-opacity, 1));
}
.bg-deepskyblue-200{
  background-color: rgba(6, 174, 212, 0.75);
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-gradient-to-b{
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-\\[\\#f5feff\\]{
  --tw-gradient-from: #f5feff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 254 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#fff\\]{
  --tw-gradient-from: #fff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[rgba\\(6\\2c 174\\2c 212\\2c 0\\.15\\)\\]{
  --tw-gradient-from: rgba(6,174,212,0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(6, 174, 212, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-\\[rgba\\(6\\2c 174\\2c 212\\2c 0\\.2\\)\\]{
  --tw-gradient-to: rgba(6, 174, 212, 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgba(6,174,212,0.2) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-white{
  --tw-gradient-to: #fff var(--tw-gradient-to-position);
}
.object-contain{
  object-fit: contain;
}
.object-cover{
  object-fit: cover;
}
.object-center{
  object-position: center;
}
.p-2{
  padding: 0.5rem;
}
.p-4{
  padding: 1rem;
}
.p-6{
  padding: 1.5rem;
}
.px-10{
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-\\[15px\\]{
  padding-left: 15px;
  padding-right: 15px;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[3px\\]{
  padding-top: 3px;
  padding-bottom: 3px;
}
.pb-14{
  padding-bottom: 3.5rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pr-8{
  padding-right: 2rem;
}
.pt-8{
  padding-top: 2rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.font-poppins{
  font-family: Poppins;
}
.text-21xl{
  font-size: 40px;
}
.text-\\[14px\\]{
  font-size: 14px;
}
.text-\\[16px\\]{
  font-size: 16px;
}
.text-\\[18px\\]{
  font-size: 18px;
}
.text-\\[26px\\]{
  font-size: 26px;
}
.text-\\[28px\\]{
  font-size: 28px;
}
.text-base{
  font-size: 16px;
}
.text-lg{
  font-size: 18px;
}
.text-xl{
  font-size: 20px;
}
.text-xs{
  font-size: 12px;
}
.font-medium{
  font-weight: 500;
}
.uppercase{
  text-transform: uppercase;
}
.capitalize{
  text-transform: capitalize;
}
.leading-6{
  line-height: 1.5rem;
}
.leading-8{
  line-height: 2rem;
}
.leading-relaxed{
  line-height: 1.625;
}
.text-gray-800{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-steelblue{
  --tw-text-opacity: 1;
  color: rgb(14 112 144 / var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.opacity-0{
  opacity: 0;
}
.opacity-100{
  opacity: 1;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_10px_30px_10px_rgba\\(8\\2c _138\\2c _178\\2c _0\\.3\\)\\]{
  --tw-shadow: 0px 10px 30px 10px rgba(8, 138, 178, 0.3);
  --tw-shadow-colored: 0px 10px 30px 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[20px_20px_20px_rgba\\(8\\2c _138\\2c _178\\2c _0\\.1\\)\\]{
  --tw-shadow: 20px 20px 20px rgba(8, 138, 178, 0.1);
  --tw-shadow-colored: 20px 20px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[20px_20px_20px_rgba\\(8\\2c _138\\2c _178\\2c _0\\.15\\)\\]{
  --tw-shadow: 20px 20px 20px rgba(8, 138, 178, 0.15);
  --tw-shadow-colored: 20px 20px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[20px_20px_20px_rgba\\(8\\2c _138\\2c _178\\2c _0\\.45\\)\\]{
  --tw-shadow: 20px 20px 20px rgba(8, 138, 178, 0.45);
  --tw-shadow-colored: 20px 20px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.backdrop-blur-md{
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-700{
  transition-duration: 700ms;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.\\[background\\:linear-gradient\\(180deg\\2c _\\#f5feff\\2c _rgba\\(59\\2c _44\\2c _124\\2c _1\\)_100\\%\\2c _\\#06aed4\\)\\]{
  background: linear-gradient(180deg, #f5feff, rgba(59, 44, 124, 1) 100%, #06aed4);
}
.\\[text-shadow\\:1px_0_0_\\#fff\\2c 0_1px_0_\\#fff\\2c -1px_0_0_\\#fff\\2c 0_-1px_0_\\#fff\\]{
  text-shadow: 1px 0 0 #fff,0 1px 0 #fff,-1px 0 0 #fff,0 -1px 0 #fff;
}
.\\[transform-origin\\:0_0\\]{
  transform-origin: 0 0;
}
.\\[transform\\:_rotate\\(-30deg\\)\\]{
  transform: rotate(-30deg);
}
.\\[transform\\:_rotate\\(20\\.2deg\\)\\]{
  transform: rotate(20.2deg);
}
.\\[transform\\:_rotate\\(21\\.8deg\\)\\]{
  transform: rotate(21.8deg);
}
body{
  margin: 0px;
  line-height: normal;
}
*,
::before,
::after {
  border-width: 0;
}
.custom-hover-underline {
  position: relative;
  display: inline-block;
}


html {
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  line-height: 1.5;
  overflow-x: hidden;


  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.custom-hover-underline::after {
  content: '';
  position: absolute;
  width: 100%;
  transform: scaleX(0);
  height: 2px;
  bottom: -3px; /* Adjust this value to control the space between text and underline */
  left: 0;
  background-color: #06AED4;
  transform-origin: bottom right;
  transition: transform 0.25s ease-out;
}

.custom-hover-underline:hover::after {
  transform: scaleX(1);
  transform-origin: bottom left;
  margin-top: 4px; /* Adjust this value to control the top margin on hover */
}
.gradient-border {

  border: 4px solid;
  border-image-slice: 1;
  border-image-source: linear-gradient(to right, rgba(6, 174, 212, 1), rgba(104, 54, 112, 1));
}

.text-shadow-custom-hero{
  color: #064357;

}
.headerBg {
    backdrop-filter: blur(10px);
    background-color: hsla(0, 0%, 67%, .1);
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, .1);
    height: auto;
    opacity: .9;
    z-index: 10;
    padding: 0.2rem 1rem;
}
.hover\\:cursor-pointer:hover{
  cursor: pointer;
}
.focus\\:border-\\[\\#0E7090\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(14 112 144 / var(--tw-border-opacity, 1));
}
.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-\\[\\#0E7090\\]:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 112 144 / var(--tw-ring-opacity, 1));
}
@media (min-width: 480px){
  .xs\\:text-\\[24px\\]{
    font-size: 24px;
  }
}
@media (min-width: 640px){
  .sm\\:mb-6{
    margin-bottom: 1.5rem;
  }
  .sm\\:h-14{
    height: 3.5rem;
  }
  .sm\\:max-w-4xl{
    max-width: 56rem;
  }
  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .sm\\:p-6{
    padding: 1.5rem;
  }
  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .sm\\:text-\\[28px\\]{
    font-size: 28px;
  }
  .sm\\:text-base{
    font-size: 16px;
  }
}
@media (min-width: 768px){
  .md\\:left-\\[75px\\]{
    left: 75px;
  }
  .md\\:top-\\[50\\%\\]{
    top: 50%;
  }
  .md\\:top-\\[95\\.4px\\]{
    top: 95.4px;
  }
  .md\\:col-span-2{
    grid-column: span 2 / span 2;
  }
  .md\\:mb-0{
    margin-bottom: 0px;
  }
  .md\\:mb-8{
    margin-bottom: 2rem;
  }
  .md\\:mt-2{
    margin-top: 0.5rem;
  }
  .md\\:h-16{
    height: 4rem;
  }
  .md\\:h-\\[30\\.9px\\]{
    height: 30.9px;
  }
  .md\\:w-1\\/2{
    width: 50%;
  }
  .md\\:w-1\\/3{
    width: 33.333333%;
  }
  .md\\:w-\\[100\\%\\]{
    width: 100%;
  }
  .md\\:w-\\[30\\.9px\\]{
    width: 30.9px;
  }
  .md\\:max-w-32{
    max-width: 8rem;
  }
  .md\\:max-w-6xl{
    max-width: 72rem;
  }
  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .md\\:flex-row{
    flex-direction: row;
  }
  .md\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }
  .md\\:p-8{
    padding: 2rem;
  }
  .md\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .md\\:text-left{
    text-align: left;
  }
  .md\\:text-\\[14px\\]{
    font-size: 14px;
  }
  .md\\:text-\\[16px\\]{
    font-size: 16px;
  }
  .md\\:text-\\[36px\\]{
    font-size: 36px;
  }
  .md\\:text-lg{
    font-size: 18px;
  }
  .md\\:leading-10{
    line-height: 2.5rem;
  }
  .md\\:leading-6{
    line-height: 1.5rem;
  }
  .md\\:leading-8{
    line-height: 2rem;
  }
  .md\\:leading-\\[40px\\]{
    line-height: 40px;
  }
}
@media (min-width: 1024px){
  .lg\\:left-\\[75px\\]{
    left: 75px;
  }
  .lg\\:top-\\[95\\.4px\\]{
    top: 95.4px;
  }
  .lg\\:mt-2{
    margin-top: 0.5rem;
  }
  .lg\\:mt-\\[50px\\]{
    margin-top: 50px;
  }
  .lg\\:flex{
    display: flex;
  }
  .lg\\:hidden{
    display: none;
  }
  .lg\\:h-20{
    height: 5rem;
  }
  .lg\\:h-\\[50\\.9px\\]{
    height: 50.9px;
  }
  .lg\\:w-32{
    width: 8rem;
  }
  .lg\\:w-\\[100\\%\\]{
    width: 100%;
  }
  .lg\\:w-\\[50\\.9px\\]{
    width: 50.9px;
  }
  .lg\\:w-\\[60\\%\\]{
    width: 60%;
  }
  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .lg\\:p-10{
    padding: 2.5rem;
  }
  .lg\\:px-16{
    padding-left: 4rem;
    padding-right: 4rem;
  }
  .lg\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .lg\\:py-14{
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }
  .lg\\:text-left{
    text-align: left;
  }
  .lg\\:text-\\[18px\\]{
    font-size: 18px;
  }
  .lg\\:text-\\[32px\\]{
    font-size: 32px;
  }
  .lg\\:text-\\[36px\\]{
    font-size: 36px;
  }
  .lg\\:text-\\[42px\\]{
    font-size: 42px;
  }
  .lg\\:text-xl{
    font-size: 20px;
  }
}
@media (min-width: 1280px){
  .xl\\:mt-2{
    margin-top: 0.5rem;
  }
  .xl\\:h-24{
    height: 6rem;
  }
  .xl\\:w-32{
    width: 8rem;
  }
  .xl\\:p-12{
    padding: 3rem;
  }
  .xl\\:text-\\[42px\\]{
    font-size: 42px;
  }
  .xl\\:text-\\[46px\\]{
    font-size: 46px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AACA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yDAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,sDAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAEjB;EAAA,WAA2B;EAA3B;AAA2B;AAE7B;;;EAGE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;;AAGA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;;;EAGlB,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,WAAW;EACX,YAAY,EAAE,sEAAsE;EACpF,OAAO;EACP,yBAAyB;EACzB,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,eAAe,EAAE,yDAAyD;AAC5E;AACA;;EAEE,iBAAiB;EACjB,qBAAqB;EACrB,2FAA2F;AAC7F;;AAEA;EACE,cAAc;;AAEhB;AACA;IACI,2BAA2B;IAC3B,sCAAsC;IACtC,mBAAmB;IACnB,wCAAwC;IACxC,YAAY;IACZ,WAAW;IACX,WAAW;IACX,oBAAoB;AACxB;AAlEA;EAAA;AAmEA;AAnEA;EAAA,sBAmEA;EAnEA;AAmEA;AAnEA;EAAA,8BAmEA;EAnEA;AAmEA;AAnEA;EAAA,2GAmEA;EAnEA,yGAmEA;EAnEA;AAmEA;AAnEA;EAAA,oBAmEA;EAnEA;AAmEA;AAnEA;EAAA;IAAA;EAmEA;AAAA;AAnEA;EAAA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA,oBAmEA;IAnEA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;AAAA;AAnEA;EAAA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA,uBAmEA;IAnEA,2DAmEA;IAnEA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA,oBAmEA;IAnEA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;AAAA;AAnEA;EAAA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA,kBAmEA;IAnEA;EAmEA;EAnEA;IAAA,kBAmEA;IAnEA;EAmEA;EAnEA;IAAA,mBAmEA;IAnEA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;AAAA;AAnEA;EAAA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;EAnEA;IAAA;EAmEA;AAAA","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;700&display=swap\");\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\nbody {\n  @apply leading-[normal] m-0;\n}\n*,\n::before,\n::after {\n  border-width: 0;\n}\n.custom-hover-underline {\n  position: relative;\n  display: inline-block;\n}\n\n\nhtml {\n  font-family: 'Poppins', sans-serif;\n  font-size: 16px;\n  line-height: 1.5;\n  overflow-x: hidden;\n\n\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.custom-hover-underline::after {\n  content: '';\n  position: absolute;\n  width: 100%;\n  transform: scaleX(0);\n  height: 2px;\n  bottom: -3px; /* Adjust this value to control the space between text and underline */\n  left: 0;\n  background-color: #06AED4;\n  transform-origin: bottom right;\n  transition: transform 0.25s ease-out;\n}\n\n.custom-hover-underline:hover::after {\n  transform: scaleX(1);\n  transform-origin: bottom left;\n  margin-top: 4px; /* Adjust this value to control the top margin on hover */\n}\n.gradient-border {\n\n  border: 4px solid;\n  border-image-slice: 1;\n  border-image-source: linear-gradient(to right, rgba(6, 174, 212, 1), rgba(104, 54, 112, 1));\n}\n\n.text-shadow-custom-hero{\n  color: #064357;\n\n}\n.headerBg {\n    backdrop-filter: blur(10px);\n    background-color: hsla(0, 0%, 67%, .1);\n    border-radius: 10px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, .1);\n    height: auto;\n    opacity: .9;\n    z-index: 10;\n    padding: 0.2rem 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
